import AstronautUpsellBannerWeb from '@assets/illustration/AstronautUpsellBannerWeb';
import { Button } from 'geniebook-ui/dist';
import React from 'react';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { ButtonSize } from 'geniebook-ui/dist/components/Button/variant';
import AstronautUpsellBannerTablet from '@assets/illustration/AstronautUpsellBannerTablet';
import { useSetAtom } from 'jotai';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

const ProgressUpsellingBanner = () => {
  const width = useViewWidth();
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });

  const buttonProperties = {
    size: (width < breakpoint.lg ? 'md' : 'lg') as ButtonSize,
    width: width < breakpoint.lg ? '211px' : '175px',
    padding: width < breakpoint.lg ? '0px' : '24px',
  };

  return (
    <div
      className={`flex max-lg:flex-row h-fit  max-md:hidden max-lg:max-h-[94px] max-lg:pr-6 lg:max-h-[143px] rounded-xl mt-[24px] bg-gradient-to-r from-[#3F39A2] to-[#19A2C0] pl-4 pr-6 py-[16px]`}
    >
      <div className={'flex-shrink-0'}>
        {width < breakpoint.lg ? (
          <AstronautUpsellBannerTablet className={'mt-[-23px] ml-[-30px]'} />
        ) : (
          <AstronautUpsellBannerWeb className={'mt-[-16px] ml-[-30px]'} />
        )}
      </div>
      <div
        className={
          'mx-[0px] mb-0 max-lg:ml-[14px] lg:mb-[16px] max-lg:pt-2 max-lg:w-full'
        }
      >
        <div className={'flex lg:flex-col max-lg:flex-row max-lg:items-start'}>
          <div className="flex flex-col">
            <h3
              className={
                "max-sm:text-[14px] min-md:text-[16px] font-extrabold font-['Open_Sans'] leading-snug"
              }
            >
              You are improving!
            </h3>
            <p
              className={
                "text-sm font-normal font-['Open_Sans'] pb-4 leading-[19px] max-lg:w-[331px]"
              }
            >
              Buy another subject to see similar improvements.
            </p>
          </div>
          <Button
            className={`lg:!w-full lg:!h-[34px] max-lg:mt-0 max-lg:!h-[46px] max-lg:!w-2/6 max-lg:my-auto max-lg:self-end !font-extrabold !px-4 max-lg:ml-auto`}
            variant="primary"
            size={buttonProperties.size}
            onClick={() => setUnlockTrialPopUp(true)}
          >
            Try for free!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProgressUpsellingBanner;
